import Loadable from 'react-loadable'

import Loader from '~/components/Loading/Cards'

export default Loadable({
  loader: () => import('./Router'),
  loading: Loader,
})
